import type {ReactElement} from 'react';
import {useContext} from 'react';
import {Icon} from '@Components/icon-v2';
import {IconShape, IconSize, IconType} from '@Components/icon-v2/icon.types';
import {goToMyStuff} from '@Libraries/my-stuff/my-stuff-library';
import {ClickableDiv} from '@Components/clickable-div';
import {useEventWizardCurrentProgressStep, useEventWizardIsSaveAsDraftOffered, useEventWizardProgressSectionLandedOn} from '@Components/event-wizard/event-wizard.hooks';
import {useDispatch} from 'react-redux';
import {onEventWizardProgressStepUpdate} from '@Components/event-wizard/event-wizard-slice';
import {EVENT_WIZARD_CONTAINER_QUERIES_CONTEXT} from '@Components/event-wizard/event-wizard-container-queries-context';
import {Text, TextSize} from '@Components/text';
import {Button, ButtonSize, ButtonType} from '@Components/button';
import {openEventWizardPreviewModal} from '@Modals/event-wizard-preview-modal/event-wizard-preview-modal.types';
import styles from './event-nav.module.scss';
import {goToOriginPage} from '@Components/event-wizard/event-wizard.helper';
import {getAssetUrl} from '@Utils/s3.util';
import {EventWizardSaveAsDraftAction} from '@Components/event-wizard/save-as-draft-action/save-as-draft-action';
import {SaveAsDraftVariant} from '@Components/event-wizard/save-as-draft-action/save-as-draft-action.types';

export function EventNav(): ReactElement<any> {
  const dispatch = useDispatch();
  const currentProgressStep = useEventWizardCurrentProgressStep();
  const progressStepLandedOn = useEventWizardProgressSectionLandedOn();
  const isSaveAsDraftOffered = useEventWizardIsSaveAsDraftOffered();
  const {isSmallScreen} = useContext(EVENT_WIZARD_CONTAINER_QUERIES_CONTEXT);

  const goBackFromNav = (): void => {
    if (progressStepLandedOn === currentProgressStep) {
      goToOriginPage();
    }
    dispatch(onEventWizardProgressStepUpdate(progressStepLandedOn));
  };

  const previewEventMobile = (): void => {
    openEventWizardPreviewModal();
  };

  if (isSmallScreen) {
    return (
      <div className={`${styles.spacingP10} flex-row-align-center justify-content-between border-s-dark _no-border-left _no-border-top _no-border-right _full-width`}>
        <div className="flex-row-align-center justify-content-center">
          <Icon className="spacing-m-r-2" onClick={goBackFromNav} icon="icon-arrow-left" size={IconSize.SIZE_ICON_20} shape={IconShape.SQUARE} type={IconType.GHOST} isUsedAsButton />
          <Text val={window.i18next.t('pmwjs_create_event_page')} size={TextSize.SMALL} bold />
        </div>
        <div className="flex-row-align-center">
          <Button onClick={previewEventMobile} size={ButtonSize.MEDIUM} type={ButtonType.TERTIARY} text={window.i18next.t('pmwjs_preview')} icon="icon-eye" />
        </div>
      </div>
    );
  }

  return (
    <div className={`${styles.spacingP10} spacing-p-3 flex-row-align-center _full-width`}>
      <Icon className="spacing-m-r-2" onClick={goBackFromNav} icon="icon-arrow-left" size={IconSize.SIZE_ICON_20} shape={IconShape.SQUARE} type={IconType.GHOST} isUsedAsButton />
      <ClickableDiv onClick={goToMyStuff} className="flex-row-align-center">
        <img className="_cursor-pointer" src={getAssetUrl('logo-postermaker-dark.svg')} alt="postermywall logo" />
      </ClickableDiv>
      {isSaveAsDraftOffered ? (
        <div className={styles.saveDraftButton}>
          <EventWizardSaveAsDraftAction variant={SaveAsDraftVariant.BUTTON} />
        </div>
      ) : null}
    </div>
  );
}
